import TextField from "@mui/material/TextField";
import React, { FC, useCallback, useState } from "react";
import FieldLabel from "shared/components/Form/components/FieldLabel";
import { InputHookResult } from "shared/hooks/useInputState";
import {
  BORDER,
  COLOR_BLACK,
  COLOR_GREY_5,
  COLOR_PRIMARY_MAIN,
} from "shared/theme/colors";
import EmptyOptions from "./components/EmptyOptions";
import { StyledAutocomplete, StyledOption, StyledOptionText } from "./styled";

const CustomMenuStyles = {
  "&.MuiPaper-root": {
    boxShadow: "0px 2px 24px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "0 0 8px 8px",
    border: BORDER(1, COLOR_GREY_5),
    borderTop: "none",

    "> div": {
      borderTop: BORDER(2, COLOR_PRIMARY_MAIN),
      padding: "0 1rem",
    },
  },
};

type Props = {
  value: string[];
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: string[],
  ) => void;
  id: string;
  placeholder: string;
  inputProps?: InputHookResult;
  onSubmitTagType: () => void;
  options: string[];
};

export const RtpExactField: FC<Props> = ({
  value,
  options,
  inputProps,
  onChange,
  id,
  onSubmitTagType,
  placeholder,
}) => {
  const inputValue = inputProps?.input.value;
  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenMenu = useCallback(
    () => inputValue?.length && setMenuOpen(!menuOpen),
    [inputValue?.length, menuOpen],
  );

  const handleEmptyOptionClick = () => {
    onSubmitTagType();
    setMenuOpen(false);
  };

  return (
    <StyledAutocomplete
      id={id}
      multiple
      value={value}
      isOpened={menuOpen}
      options={options}
      disableCloseOnSelect
      onChange={(event, newValue) => {
        onChange(event, newValue);
        handleOpenMenu();
      }}
      onBlur={() => setMenuOpen(false)}
      open={menuOpen}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue, reason) => {
        if (reason === "input") setMenuOpen(true);
        inputProps?.setValue(newInputValue);
      }}
      getOptionLabel={(option) => option}
      isOptionEqualToValue={(option, value) =>
        option && value ? option === value : false
      }
      renderOption={(props, option, { selected }) => {
        return (
          <StyledOption
            {...props}
            key={option}
            data-testid={`option-${selected}`}
          >
            <StyledOptionText color={COLOR_BLACK} variant="bodyMRegular">
              {option}
            </StyledOptionText>
          </StyledOption>
        );
      }}
      renderInput={(params) => (
        <>
          <FieldLabel label="RTP Exact" labelColor={COLOR_BLACK} />
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              // Apply styles to hide the only dropdown arrow icon
              sx: {
                "& .MuiAutocomplete-popupIndicator": {
                  display: "none",
                },
              },
            }}
            placeholder={placeholder}
            onClick={handleOpenMenu}
          />
        </>
      )}
      ListboxProps={{
        sx: {
          padding: 0,
          borderTop: `${BORDER(2, COLOR_PRIMARY_MAIN)}`,
        },
      }}
      slotProps={{
        paper: {
          sx: CustomMenuStyles,
        },
      }}
      noOptionsText={
        <EmptyOptions
          inputValue={inputValue}
          onClick={handleEmptyOptionClick}
        />
      }
    />
  );
};
